"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.AccordionPanel = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("../../utils/helpers");

var _MarkdownRenderer = _interopRequireDefault(require("../MarkdownRenderer"));

var _Accordion = require("./Accordion.style");

var AccordionPanel = function AccordionPanel(_ref) {
  var copy = _ref.copy,
      eventKey = _ref.eventKey,
      heading = _ref.heading,
      isLargeView = _ref.isLargeView,
      openPanel = _ref.openPanel,
      show = _ref.show,
      onAccordionChange = _ref.onAccordionChange;

  var _ref2 = (0, _react.useState)(true),
      _ref3 = _slicedToArray(_ref2, 2),
      isExpanded = _ref3[0],
      setIsExpanded = _ref3[1];

  var activeIcon = show && isExpanded ? 'ChevronDown' : 'ChevronRight';
  var iconName = isLargeView ? 'ChevronRight' : activeIcon;
  var finalCopy = isLargeView ? '' : copy;

  var openToggle = function openToggle() {
    if (isLargeView && !show) {
      openPanel(eventKey);
    } else if (show) {
      setIsExpanded(!isExpanded);
    } else {
      openPanel(eventKey);
      setIsExpanded(true);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Accordion.AccordionPanelWrapper, null, /*#__PURE__*/_react.default.createElement(_Accordion.AccordionHeading, {
    onClick: function onClick() {
      openToggle();
      onAccordionChange(heading);
    },
    selected: show,
    size: "medium",
    isExpanded: isExpanded
  }, heading, /*#__PURE__*/_react.default.createElement(_Accordion.AccordionIcon, {
    name: iconName,
    color: show ? 'white' : 'black',
    isLargeView: isLargeView
  })), show && isExpanded && /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
    html: (0, _helpers.ellipsify)(finalCopy, 1500),
    copySize: "medium"
  }));
};

exports.AccordionPanel = AccordionPanel;
AccordionPanel.propTypes = {
  copy: _propTypes.default.string,
  eventKey: _propTypes.default.number,
  heading: _propTypes.default.string,
  isLargeView: _propTypes.default.bool,
  openPanel: _propTypes.default.func,
  show: _propTypes.default.bool,
  onAccordionChange: _propTypes.default.func
};
AccordionPanel.defaultProps = {
  copy: '',
  eventKey: 0,
  heading: '',
  isLargeView: false,
  openPanel: function openPanel() {},
  show: false,
  onAccordionChange: function onAccordionChange() {}
};
var _default = AccordionPanel;
exports.default = _default;